import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { FileHandlingComponent } from 'projects/admin/src/app/partials/data/file-handling/file-handling.component';

@Component({
  selector: 'app-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.scss']
})
export class DocumentsListComponent extends BaseList implements OnInit {

  @ViewChild('filehandler') filehandler: FileHandlingComponent;

  public inEdit = false;
  public uploadOpened = false; // @deprecated
  public submitting = false;
  public editDocument: ResourceModel = null;
  public form: UntypedFormGroup = this.fb.group({
    filename: new UntypedFormControl('', [Validators.required]),
  });

  public documents: Array<ResourceModel> = [];

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    private fb: UntypedFormBuilder,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('files').subscribe({
      next: (documents: any) => {
        this.documents = [];
        documents.data.forEach((ac: any) => {
          this.documents.push(new ResourceModel().deserialize(ac));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  onNew(): void {
    this.filehandler.openFileUpload();
  }

  onStartDelete(resource: ResourceModel): void {
    this.filehandler.onDeleteFile(this.documents, resource);
  }

  onDelete(resources: Array<ResourceModel>): void {
    this.documents = resources;
  }

  onDownload(resource: ResourceModel): void {
    this.filehandler.downloadFile(resource);
  }

  onFilesUpload(files: Array<ResourceModel>): void {
    files.forEach((file: ResourceModel) => {
      this.documents.push(file);
    });
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        filename: this.addExtension(this.form.value.filename),
        candidate: this.form.value.candidate,
        observer: this.form.value.observer,
      };
      this.api.saveModel('files', this.editDocument.id, payload).subscribe({
        next: (result: any) => {
          this.editDocument.public_name = result.data.public_name;
          this.editDocument.permissions = result.data.permissions;
          this.ui.toastSuccess(this.transloco.translate('ac_files.filename_changed', { value: this.editDocument.public_name }), this.transloco.translate('common.changed'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onEdit(resource: ResourceModel): void {
    if (this.auth.hasRight('admin.document.edit')) {
      this.editDocument = resource;
      this.startEdit();
    }
  }

  onCancel(): void {
    this.editDocument = null;
    this.stopEdit();
  }

  startEdit(): void {
    this.form.patchValue({
      filename: this.deleteExtension(this.editDocument.public_name),
    });
    this.inEdit = true;
  }

  stopEdit(): void {
    this.form.reset();
    this.inEdit = false;
  }

  private deleteExtension(filename: string): string {
    return filename.replace(/\..*$/gm, '');
  }

  private addExtension(filename: string): string {
    return filename + this.editDocument.public_name.match(/\..*$/gm)[0];
  }

}
